<template>
  <apply-form :jobofferId="jobofferId" />
</template>

<script>
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import applyForm from '@/components/application/apply-form.vue';
import i18n from '@/i18n';

extend('required', {
  ...required,
  message: i18n.t('validation.fieldIsMandatory')
});

export default {
  computed: {
    jobofferId() {
      return this.$route.params.jobofferId;
    }
  },

  components: {
    applyForm
  }
};
</script>
